/**
 * Navigation service for programmatic navigation outside of React components.
 * Used by Redux sagas to navigate after login/logout operations.
 * 
 * @author fabrice.miras@vitecsoftware.com
 */

import { NavigateFunction } from 'react-router-dom';

let navigateFunction: NavigateFunction | null = null;

/**
 * Set the navigate function from the router context.
 * Called once when the app initializes inside RouterProvider.
 */
export const setNavigate = (navigate: NavigateFunction) => {
  navigateFunction = navigate;
};

/**
 * Navigate to a path programmatically.
 * Can be used from sagas, services, or any non-React code.
 */
export const navigate = (to: string, options?: { replace?: boolean; state?: any }) => {
  if (navigateFunction) {
    navigateFunction(to, options);
  } else {
    console.warn('Navigation service not initialized. Falling back to window.location.');
    window.location.href = to;
  }
};

/**
 * Get the current navigate function.
 */
export const getNavigate = () => navigateFunction;
